import script from "./CardEditPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardEditPopup.vue?vue&type=script&setup=true&lang=ts"

import "./CardEditPopup.vue?vue&type=style&index=0&id=d34fb9c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d34fb9c0"]])

export default __exports__